import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import IncidentActions, { IncidentRedux, IncidentTypes } from '../Redux/IncidentRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const IncidentCRUDObservable = createCRUDObservable({
  mainRedux: IncidentRedux,
  reduxPath: 'incident',
})

const incidentsEpic = (action$, store, { Api }) =>
  action$.ofType(IncidentTypes.IncidentRequest)
    .mergeMap(({ start_date, end_date }) => (
      Observable
        .fromPromise(Api.incident.getIncidentExcel(start_date, end_date)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            IncidentActions.IncidentSuccess(data, fileName),
          ]
        })
    ))

const centersIncidentsEpic = (action$, store, { Api }) =>
  action$.ofType(IncidentTypes.CentersIncidentRequest)
    .mergeMap(({ start_date, end_date, centerId }) => (
      Observable
        .fromPromise(Api.incident.getCentersIncidentExcel(start_date, end_date, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            IncidentActions.CentersIncidentSuccess(data, fileName),
          ]
        })
    ))

export const IncidentObservers = Object.assign({}, IncidentCRUDObservable.observers, {})
export const incidentEpic = combineEpics(
  IncidentCRUDObservable.epic,
  incidentsEpic,
  centersIncidentsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/IncidentObservable.js